import { render, staticRenderFns } from "./StatementStatus.vue?vue&type=template&id=24a23d64&scoped=true&lang=pug"
import script from "./StatementStatus.vue?vue&type=script&lang=js"
export * from "./StatementStatus.vue?vue&type=script&lang=js"
import style0 from "./StatementStatus.vue?vue&type=style&index=0&id=24a23d64&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a23d64",
  null
  
)

export default component.exports